/* eslint-disable import/prefer-default-export */
import {
  getStudentAuthStatus, getStudentTagInfo,
} from '@/api/student';
import { marketDistribute } from '@/api/card';
import { env } from '@hb/NBridge/lib/h5';
import { STUDENT_AUTH_STATUS } from './consts';
import { getTokenAndKey } from '../../utils';


export async function getStudentAuthInfo() {
  const { token } = await getTokenAndKey();
  return Promise.all([
    getStudentAuthStatus({ token }).then((v) => v.data || null).catch(() => null),
    getStudentTagInfo({ token }).then((v) => v.data || null).catch(() => null),
  ]).then(([
    auth, tag,
  ]) => {
    if (!auth && !tag) {
      return null;
    }
    const info = {
      college: '',
      userName: '',
    };
    if (auth) {
      info.college = auth.schoolName;
      info.userName = auth.stuName;
    } else if (tag) {
      Object.assign(info, tag);
    }
    return info;
  });
}

export async function checkIfGetAward({ activityCode, componentKey }) {
  const { token } = await getTokenAndKey();
  return marketDistribute({
    activityCode,
    token,
    channelId: env.platformCode,
    methodName: 'queryAwardReceiveStatus',
    param: JSON.stringify({ activityCode, componentKey }),
  }).then((v) => {
    if (v && v.data) {
      if (v.data.length === 0) {
        return false;
      }
      return v.data[0].receiveStatus === 1;
    }
    return true;
  }).catch(() => true);
}

export async function giveAwayAward({ activityCode, componentKey }) {
  const { token } = await getTokenAndKey();
  return marketDistribute({
    activityCode,
    token,
    channelId: env.platformCode,
    methodName: 'register',
    param: JSON.stringify({ activityCode, componentKey, channel: env.platformCode }),
  });
}

export async function shouldGiveAwayAward({ activityCode, componentKey }) {
  const { token } = await getTokenAndKey();
  const isStudent = await getStudentAuthStatus({ token }).then((v) => {
    if (v && v.data && v.data.authState === STUDENT_AUTH_STATUS.PASSED) {
      return true;
    }
    return false;
  }).catch(() => false);
  if (!isStudent) {
    return false;
  }
  const has = await checkIfGetAward({ activityCode, componentKey });
  if (!has) {
    return true;
  }
  return false;
}

export function getPort() {
  if (env.isEasyBikeApp) {
    return '0';
  } if (env.isAliMP || env.isAliMPMonitor) {
    return '1';
  }
  return '2';
}
